import NotificationBanner from "./notificationbanner";
// import PropTypes from 'prop-types';

// New component with image and name
const NotificationCard = ({ imgUrl, name, status, textColor, text, contactNumber, thirdPartyShipping }) => {
  if (thirdPartyShipping) {
    return (
      <div className="se-border se-min-w-full se-w-[95%] se-border-green-300 se-rounded-lg se-p-4 se-bg-white se-flex se-flex-col se-space-y-2">

        {/* Notification Banner */}
        <NotificationBanner
          status={status}
          textColor="se-gray-800"
          text={text}
          contactNumber={contactNumber}
        />
      </div>
    );
  } else {
    return (
      <div className="se-border se-min-w-full se-w-[95%] se-border-green-300 se-rounded-lg se-p-4 se-bg-white se-flex se-flex-col se-space-y-2">
        <div className="se-flex se-justify-between se-pb-2">
          <div className="se-flex se-items-center">
            {/* Profile image or icon */}
            <img
              src={imgUrl}
              alt={`${name}'s profile`}
              className="se-h-10 se-w-10 se-rounded-full se-bg-yellow-500 se-flex se-items-center se-justify-center se-mr-3"
            />
            {/* Name */}
            <span className="se-font-medium se-text-gray-900">{name}</span>
          </div>
          {(status === "OUT_FOR_DELIVERY") &&
            <button>
              <a href={"tel:" + contactNumber}>
                <img src="/images/call_now.png" alt="Phone Icon" className="se-w-10 se-h-10" />
              </a>
            </button>
          }
        </div>
        {/* Notification Banner */}
        <NotificationBanner
          status={status}
          textColor="se-gray-800"
          text={text}
          contactNumber={contactNumber}
        />
      </div>
    );
  }
};

// NotificationCard.propTypes = {
//   imgUrl: PropTypes.string.isRequired,      // URL of the image or icon
//   name: PropTypes.string.isRequired,        // Name to display
//   textColor: PropTypes.string.isRequired,   // The color of the text in the banner
//   text: PropTypes.string.isRequired,        // The text to display in the banner
//   status: PropTypes.string.isRequired,      // The status to determine colors
// };

export default NotificationCard;